var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 23.893,
    viewBox: "0 0 22.5 23.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86015",
    "data-name": "Group 86015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86014",
    "data-name": "Group 86014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85999",
    "data-name": "Group 85999",
    transform: "translate(4.53 4.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242370",
    "data-name": "Path 242370",
    d: "M152.19,142.321h-5.785a1.34,1.34,0,0,1-1.328-1.157,5.1,5.1,0,0,0-.775-2.313,6.715,6.715,0,1,1,9.99,0,5.1,5.1,0,0,0-.775,2.313,1.34,1.34,0,0,1-1.328,1.157ZM149.3,128.4H149.2a5.968,5.968,0,0,0-4.346,9.956,6.011,6.011,0,0,1,.959,2.71.6.6,0,0,0,.588.512h5.785a.6.6,0,0,0,.588-.512,6.01,6.01,0,0,1,.959-2.71A5.968,5.968,0,0,0,149.3,128.4Z",
    transform: "translate(-142.583 -127.65)",
    fill: "#8e8e8e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86007",
    "data-name": "Group 86007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86000",
    "data-name": "Group 86000",
    transform: "translate(10.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242371",
    "data-name": "Path 242371",
    d: "M240.874,64.729a.373.373,0,0,1-.373-.373V62.793a.373.373,0,0,1,.747,0v1.563A.373.373,0,0,1,240.874,64.729Z",
    transform: "translate(-240.501 -62.42)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86001",
    "data-name": "Group 86001",
    transform: "translate(5.438 1.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242372",
    "data-name": "Path 242372",
    d: "M157.755,87.016a.373.373,0,0,1-.324-.187l-.788-1.366a.373.373,0,1,1,.647-.373l.788,1.366a.373.373,0,0,1-.323.56Z",
    transform: "translate(-156.593 -84.904)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86002",
    "data-name": "Group 86002",
    transform: "translate(1.457 5.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242373",
    "data-name": "Path 242373",
    d: "M96.945,147.884a.372.372,0,0,1-.186-.05l-1.4-.81a.373.373,0,0,1,.373-.647l1.4.81a.373.373,0,0,1-.187.7Z",
    transform: "translate(-95.169 -146.327)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86003",
    "data-name": "Group 86003",
    transform: "translate(0 10.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242374",
    "data-name": "Path 242374",
    d: "M74.74,230.982H73.059a.373.373,0,1,1,0-.747H74.74a.373.373,0,1,1,0,.747Z",
    transform: "translate(-72.686 -230.235)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86004",
    "data-name": "Group 86004",
    transform: "translate(20.072 10.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242375",
    "data-name": "Path 242375",
    d: "M384.432,230.982h-1.681a.373.373,0,0,1,0-.747h1.681a.373.373,0,0,1,0,.747Z",
    transform: "translate(-382.378 -230.235)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86005",
    "data-name": "Group 86005",
    transform: "translate(18.893 5.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242376",
    "data-name": "Path 242376",
    d: "M364.553,147.883a.373.373,0,0,1-.187-.7l1.4-.81a.373.373,0,0,1,.373.647l-1.4.81A.371.371,0,0,1,364.553,147.883Z",
    transform: "translate(-364.18 -146.326)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86006",
    "data-name": "Group 86006",
    transform: "translate(15.526 1.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242377",
    "data-name": "Path 242377",
    d: "M312.614,87.016a.373.373,0,0,1-.323-.56l.789-1.366a.373.373,0,1,1,.647.373l-.788,1.366A.373.373,0,0,1,312.614,87.016Z",
    transform: "translate(-312.241 -84.903)",
    fill: "#fd930d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86010",
    "data-name": "Group 86010",
    transform: "translate(9.234 11.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86008",
    "data-name": "Group 86008",
    transform: "translate(1.643 1.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242378",
    "data-name": "Path 242378",
    d: "M240.874,265.076a.373.373,0,0,1-.373-.373v-5.417a.373.373,0,0,1,.747,0V264.7A.373.373,0,0,1,240.874,265.076Z",
    transform: "translate(-240.501 -258.912)",
    fill: "#fd930d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86009",
    "data-name": "Group 86009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242379",
    "data-name": "Path 242379",
    d: "M217.169,238.336a.373.373,0,0,1-.3-.15,5.3,5.3,0,0,0-.627-.7,5.014,5.014,0,0,0-.9-.675.373.373,0,0,1,.376-.645,5.758,5.758,0,0,1,1.039.776,5.967,5.967,0,0,1,.416.431c.132-.151.271-.3.416-.431a5.755,5.755,0,0,1,1.039-.776.373.373,0,0,1,.376.645,5.008,5.008,0,0,0-.9.675,5.31,5.31,0,0,0-.627.7A.374.374,0,0,1,217.169,238.336Z",
    transform: "translate(-215.153 -236.111)",
    fill: "#fd930d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86011",
    "data-name": "Group 86011",
    transform: "translate(8.033 18.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242380",
    "data-name": "Path 242380",
    d: "M201.989,346.46h-4.3a1.063,1.063,0,0,1-1.062-1.062v-2.53a.373.373,0,0,1,.373-.373h5.678a.373.373,0,0,1,.373.373v2.53A1.063,1.063,0,0,1,201.989,346.46Zm-4.616-3.218V345.4a.315.315,0,0,0,.315.315h4.3a.315.315,0,0,0,.315-.315v-2.157Z",
    transform: "translate(-196.626 -342.495)",
    fill: "#8e8e8e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86012",
    "data-name": "Group 86012",
    transform: "translate(8.033 19.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242381",
    "data-name": "Path 242381",
    d: "M202.676,368.07H197a.373.373,0,0,1,0-.747h5.678a.373.373,0,0,1,0,.747Z",
    transform: "translate(-196.625 -367.323)",
    fill: "#8e8e8e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86013",
    "data-name": "Group 86013",
    transform: "translate(9.097 21.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242382",
    "data-name": "Path 242382",
    d: "M215.184,394.673a2.151,2.151,0,0,1-2.148-2.148.373.373,0,0,1,.747,0,1.4,1.4,0,0,0,2.8,0,.373.373,0,0,1,.747,0A2.151,2.151,0,0,1,215.184,394.673Z",
    transform: "translate(-213.035 -392.151)",
    fill: "#8e8e8e",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/Bulb.6f956a211c7c9010c263e06955e9f265.svg";
export { ForwardRef as ReactComponent };